import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import index from '../view/index.vue'
import login from '../view/login.vue'
// import editPw from '../view/page/editPw/editPw.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: '网联客优易购管理平台'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        title: '网联客优易购管理平台登录'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js